// 对账单详细信息页面
<template>
    <div class="main-center" style="margin-top: 80px;">
        <!--对账单基本信息卡片-->
        <div class="cardBox">
            <div class="cardBody">
                <el-row :gutter="20">
                    <el-col style="width: 70%;margin-bottom: 10px">
                        <div class="cardTitle flex flex-align">
                            <img src="../../../assets/image/icon/order1.svg" alt="">
                            <span>{{$t("billsDetails.title")}}</span>
                        </div>
                        <div class="flex flex-space-around margin-bottom">
                            <!--对账单号-->
                            <div class="inputName" style="margin-top: 10px">
                                <div class="inputName-title">
                                    <span>{{$t("billsDetails.soaNo")}}</span>
                                </div>
                                <el-input v-model="statementOfAccount.soaNo" readonly/>
                            </div>
                            <!--结算单位代码-->
                            <div class="inputName" style="margin-top: 10px">
                                <div class="inputName-title">
                                    <span>{{$t("billsDetails.balanceUnits")}}</span>
                                </div>
                                <el-input v-model="statementOfAccount.balanceUnits" readonly/>
                            </div>
                            <!--结算单位-->
                            <div class="inputName" style="margin-top: 10px">
                                <div class="inputName-title">
                                    <span>{{$t("billsDetails.balanceUnitsEn")}}</span>
                                </div>
                                <el-input v-model="statementOfAccount.balanceUnitsEn" readonly/>
                            </div>
                        </div>
                        <div class="flex flex-space-around margin-bottom">
                            <!--结算单位(CN)-->
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t("billsDetails.balanceUnitsCn")}}</span>
                                </div>
                                <el-input v-model="statementOfAccount.balanceUnitsCn" readonly/>
                            </div>
                            <!--创建人-->
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t("billsDetails.createdByUser")}}</span>
                                </div>
                                <el-input v-model="statementOfAccount.createdByUser" disabled/>
                            </div>
                            <!--创建时间-->
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t("billsDetails.createdDtmLoc")}}</span>
                                </div>
                                <el-date-picker v-model="statementOfAccount.createdDtmLoc" type="date"
                                                class="dateInput1" disabled/>
                            </div>
                        </div>
                        <div class="flex flex-space-around margin-bottom">
                            <!--确认状态-->
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t("billsDetails.confirmFlag")}}</span>
                                </div>
                                <el-select v-model="statementOfAccount.confirmFlag"
                                           placeholder=""
                                           clearable disabled>
                                    <el-option v-for="item in confirmStatusOptions"
                                               :key="item.codeValue" :label="getDisplayValue(item)"
                                               :value="item.codeValue">
                                        <span style="float: left">{{ item.displayValueCn }}</span>
                                        <span
                                            style="float: right; color: #8492a6; font-size: 13px">{{ item.displayValue }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <!--开票状态-->
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t("billsDetails.invoiceFlag")}}</span>
                                </div>
                                <el-select v-model="statementOfAccount.invoiceFlag"
                                           placeholder=""
                                           clearable disabled>
                                    <el-option v-for="item in invoiceStatusOptions"
                                               :key="item.codeValue" :label="getDisplayValue(item)"
                                               :value="item.codeValue">
                                        <span style="float: left">{{ item.displayValueCn }}</span>
                                        <span
                                            style="float: right; color: #8492a6; font-size: 13px">{{ item.displayValue }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <!--备注-->
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t("billsDetails.remark")}}</span>
                                </div>
                                <el-input v-model="statementOfAccount.remark" clearable
                                          :readonly="getReadOnlyFlag"
                                          @input="formatUpper('statementOfAccount','remark',statementOfAccount.remark)"/>
                            </div>
                        </div>
                    </el-col>
                    <el-col style="width: 30%;">
                        <div class="cardTitle flex flex-align">
                            <img src="../../../assets/image/icon/order12.svg" alt="">
                            <span>{{$t("billsDetails.tableCurrencyAmountInfo.title")}}</span>
                            <span style="font-size: 12px;color: #999999">{{$t("billsDetails.tableCurrencyAmountInfo.note")}}</span>
                        </div>
                        <div class="cardBody">
                            <el-table :data="tableCurrencyAmountInfo" ref="tablesAmountReceivableData"
                                      class="show_table" style="width:100%;margin-top:5px"
                                      height="169" max-height="169" highlight-current-row
                                      :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                      :row-style="{height:'20px'}" :cell-style="{padding:'0px'}"
                                      :empty-text="$t('common.noData')">
                                <!--序号-->
                                <el-table-column min-width="50" show-overflow-tooltip type="index"
                                                 :label="$t('billsDetails.index')" align="center"/>
                                <!--币种-->
                                <el-table-column min-width="80" show-overflow-tooltip
                                                 prop="currency" :label="$t('billsDetails.tableCurrencyAmountInfo.currency')" align="center"/>
                                <!--金额-->
                                <el-table-column min-width="100" show-overflow-tooltip
                                                 prop="amount" :label="$t('billsDetails.tableCurrencyAmountInfo.amount')" align="center"/>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="cardBox">
            <div class="cardBody">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="$t('billsDetails.tableVoyageInfo.title')" name="first">
                        <vxe-table show-header-overflow show-overflow
                                   ref="tableVoyageInfo" class="vxeTable"
                                   :align="allAlign" size="small"
                                   height="280"
                                   :row-config="{isCurrent: true, isHover: true}"
                                   :column-config="{resizable: true}"
                                   :data="tableVoyageInfo"
                                   :print-config="{}"
                                   :checkbox-config="{checkStrictly: true}">
                            <vxe-column type="checkbox" width="45">
                                <template #checkbox="{row}">
                                    <vxe-checkbox v-model="row.checked" :indeterminate="ifVVLIndeterminate(row)"
                                                  @change="selectVVLChangeEvent(row)"></vxe-checkbox>
                                </template>
                            </vxe-column>
                            <!--序号-->
                            <vxe-column type="seq" width="50" title="billsDetails.index"></vxe-column>
                            <!--船舶代码-->
                            <vxe-column field="vesselCode" width="220" title="billsDetails.tableVoyageInfo.vesselCode" sortable></vxe-column>
                            <!--船舶名称-->
                            <vxe-column field="vesselName" width="280" title="billsDetails.tableVoyageInfo.vesselName" sortable></vxe-column>
                            <!--航次-->
                            <vxe-column field="voyageNo" width="220" title="billsDetails.tableVoyageInfo.voyageNo" sortable></vxe-column>
                            <!--航段-->
                            <vxe-column field="voyageLeg" title="billsDetails.tableVoyageInfo.voyageLeg" sortable></vxe-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('billsDetails.tableFreightReceivableInfo.title')" name="second">
                        <el-col style="width: 25%" :span="12">
                            <vxe-table show-header-overflow show-overflow
                                       ref="tableBLNoInfo" class="vxeTable"
                                       height="280" size="small"
                                       :row-config="{isCurrent: true, isHover: true}"
                                       :column-config="{resizable: true}"
                                       :export-config="{}"
                                       :print-config="{}"
                                       :align="allAlign"
                                       :data="tableBLNoInfo"
                                       :checkbox-config="{checkStrictly: true}">
                                <vxe-column type="checkbox" width="45">
                                    <template #checkbox="{row}">
                                        <vxe-checkbox v-model="row.checked" :indeterminate="ifBlNoIndeterminate(row)"
                                                      @change="selectBlNoChangeEvent(row)"></vxe-checkbox>
                                    </template>
                                </vxe-column>
                                <!--序号-->
                                <vxe-column type="seq" width="50" title="billsDetails.index"></vxe-column>
                                <!--开航日-->
                                <vxe-column field="blNo" title="billsDetails.tableBLNoInfo.blNo" sortable/>
                            </vxe-table>
                        </el-col>
                        <el-col style="width: 73%; margin-left: 20px" :span="12">
                            <vxe-table show-header-overflow show-overflow
                                       ref="tableFreightReceivableInfo" class="vxeTable"
                                       height="280" size="small"
                                       :row-config="{isCurrent: true, isHover: true}"
                                       :column-config="{resizable: true}"
                                       :export-config="{}"
                                       :print-config="{}"
                                       :align="allAlign"
                                       :data="tableFreightReceivableInfo"
                                       :checkbox-config="{checkStrictly: true}"
                                       @checkbox-change="handleFreightReceivableInfoChecked">
                                <vxe-column type="checkbox" width="45"></vxe-column>
                                <!--序号-->
                                <vxe-column type="seq" width="50" title="billsDetails.index"></vxe-column>
                                <!--开航日-->
                                <vxe-column field="saillingDate" width="125" title="billsDetails.tableFreightReceivableInfo.saillingDate" sortable/>
                                <!--船舶代码-->
                                <vxe-column field="vesselCode" width="120" title="billsDetails.tableFreightReceivableInfo.vesselCode" sortable></vxe-column>
                                <!--船舶名称-->
                                <vxe-column field="vesselName" width="220" title="billsDetails.tableFreightReceivableInfo.vesselName" sortable></vxe-column>
                                <!--航次-->
                                <vxe-column field="voyageNo" width="120" title="billsDetails.tableFreightReceivableInfo.voyageNo" sortable></vxe-column>
                                <!--航段-->
                                <vxe-column field="voyageLeg" width="120" title="billsDetails.tableFreightReceivableInfo.voyageLeg" sortable></vxe-column>
                                <!--提单号-->
                                <vxe-column field="blNo" width="180" title="billsDetails.tableFreightReceivableInfo.blNo" sortable></vxe-column>
                                <!--费项代码-->
                                <vxe-column field="chargeCode" width="130" title="billsDetails.tableFreightReceivableInfo.chargeCode" sortable></vxe-column>
                                <!--费项名称（根据系统语言显示中文/英文名称）-->
                                <vxe-column field="chargeName" width="150" title="billsDetails.tableFreightReceivableInfo.chargeName">
                                    <template slot-scope="scope">
                                        <span>{{getChargeNameDisplayValue(scope.row)}}</span>
                                    </template>
                                </vxe-column>
                                <!--币种-->
                                <vxe-column field="currency" width="110" title="billsDetails.tableFreightReceivableInfo.currency" sortable></vxe-column>
                                <!--金额-->
                                <vxe-column field="amount" width="120" title="billsDetails.tableFreightReceivableInfo.amount" sortable></vxe-column>
                                <!--客户名称-->
                                <vxe-column field="payerName" width="220" title="billsDetails.tableFreightReceivableInfo.payerName">
                                    <template slot-scope="scope">
                                        <span>{{getCustomerNameDisplayValue(scope.row)}}</span>
                                    </template>
                                </vxe-column>
                                <!--计价数量-->
                                <vxe-column field="caculateQty" width="130" title="billsDetails.tableFreightReceivableInfo.caculateQty" sortable></vxe-column>
                                <!--箱型代码-->
                                <vxe-column field="containerType" width="140" title="billsDetails.tableFreightReceivableInfo.containerType"></vxe-column>
                                <!--货类-->
                                <vxe-column field="cargoTypeCode" width="150" title="billsDetails.tableFreightReceivableInfo.cargoTypeCode">
                                    <template slot-scope="scope">
                                        <span>{{getCargoTypeName(scope.row.cargoTypeCode)}}</span>
                                    </template>
                                </vxe-column>
                                <!--协议号-->
                                <vxe-column field="agreementNo" width="150" title="billsDetails.tableFreightReceivableInfo.agreementNo"></vxe-column>
                            </vxe-table>
                        </el-col>
                    </el-tab-pane>
                </el-tabs>
                <!--费用功能按钮-->
                <div style="margin-bottom: 5px;margin-top: 5px">
                    <!--全选-->
                    <el-button icon="el-icon-my-selectAll" plain size="mini"
                               :disabled="getReadOnlyFlag"
                               @click="checkAllBtnClick(true)">
                        {{ selectAll }}
                    </el-button>
                    <!--反选-->
                    <el-button icon="el-icon-my-selectInverse" plain size="mini"
                               :disabled="getReadOnlyFlag"
                               @click="checkAllBtnClick(false)">
                        {{ selectInverse }}
                    </el-button>
                    <el-button icon="el-icon-delete-solid" type="success" size="mini"
                               :disabled="getReadOnlyFlag"
                               @click="addCostBtnClick">
                        {{$t("billsDetails.button.addCostBtn")}}
                    </el-button>
                    <el-button icon="el-icon-upload" type="primary" size="mini"
                               :disabled="getReadOnlyFlag"
                               @click="removeCostBtnClick">
                        {{$t("billsDetails.button.removeCostBtn")}}
                    </el-button>
                </div>
            </div>
        </div>

        <!--底部按钮组-->
        <div class="footer-group">
            <!--保存按钮-->
            <el-button class="save-green-button" type="success"
                       :disabled="!getSaveBtnStatus"
                       @click="returnSave">
                {{ $t('common.saveBtn') }}
            </el-button>
            <!--确认按钮-->
            <el-button class="save-yellow-button" type="primary"
                       :disabled="!getConfirmBtnStatus"
                       @click="returnConfirm">
                {{$t("billsDetails.button.ConfirmBtn")}}
            </el-button>
            <!--取消确认按钮-->
            <el-button class="return-button" type="info"
                       :disabled="!getCancelConfirmBtnStatus"
                       @click="returnCancelConfirm">
                {{$t("billsDetails.button.cancelConfirmBtn")}}
            </el-button>
            <!--申请开票按钮-->
            <el-button class="save-blue-button"
                       :disabled="!getInvoiceBtnStatus"
                       @click="returnInvoice">
                {{$t("billsDetails.button.invoiceBtn")}}
            </el-button>
            <!--删除按钮-->
            <el-button type="info" class="return-button"
                       :disabled="!getDeleteBtnStatus"
                       @click="returnDelete">
                {{ $t('common.deleteButton') }}
            </el-button>
            <!--下载对账单按钮-->
            <el-dropdown style="margin-left: 10px" trigger="click"
                         @command="billsDownload">
                <el-button type="primary" plain
                           :disabled="statementOfAccount.statementOfAccountId == null || statementOfAccount.statementOfAccountId === ''">
                    <span style="font-size: 17px;">{{ $t('billsDetails.button.billsDownload') }}</span><i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="PDF">
                        <i class="el-icon-download">{{ $t('billsDetails.button.billsDownloadPdfBtn') }}</i>
                    </el-dropdown-item>
                    <el-dropdown-item command="EXCEL">
                        <i class="el-icon-download">{{ $t('billsDetails.button.billsDownloadExcelBtn') }}</i>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <!--添加费用弹出框-->
        <el-dialog :visible.sync="freightAddDialogShow" width="85%" top="5%">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-zoom-in">{{ $t('billsDetails.button.addCostBtn') }}</i>
            </div>
            <div class="flex flex-space-between">
                <!--船名/航次查询条件-->
                <el-col :span="7" style="width: 46.4%">
                    <div class="inputName-left">
                        <el-col :span="7" style="width: 35%">
                            <div class="inputName-left">
                                <div class="inputName-title-left">
                                    <span>{{ $t('confirmFreight.vesselCode') }}</span>
                                </div>
                                <el-input v-model="freightAddDialogSearch.vesselCode"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                        </el-col>
                        <el-col :span="7" style="width: 30%">
                            <div class="inputName-left">
                                <div class="inputName-title-left">
                                    <span>{{ $t('confirmFreight.voyageNo') }}</span>
                                </div>
                                <el-input v-model="freightAddDialogSearch.voyageNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                        </el-col>
                        <el-col :span="6" style="width: 30%">
                            <div class="inputName-left">
                                <div class="inputName-title-left">
                                    <span>{{ $t('confirmFreight.voyageLeg') }}</span>
                                </div>
                                <el-input v-model="freightAddDialogSearch.voyageLeg"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                        </el-col>
                        <el-col :span="3" style="width: 10%">
                            <!--VVL弹框-->
                            <el-popover ref="popover" placement="bottom" width="700" trigger="click"
                                        @hide="boatListShow=false">
                                <div>
                                    <div class="flex flex-space-between">
                                        <!--船名查询条件-->
                                        <div class="inputName-left boatBox">
                                            <div class="inputName-title-left">
                                                <span>{{ $t('booking.popover.vessel') }}</span>
                                            </div>
                                            <el-input v-model="freightAddDialogSearch.vesselCode"
                                                      :placeholder="$t('common.pleaseEnter')" clearable
                                                      @focus="showVesselList">
                                                <img src="../../../assets/image/icon/classification.svg"
                                                     slot="suffix"
                                                     @click="showVesselList">
                                            </el-input>
                                            <!--船名列表-->
                                            <div class="boatBox-list-box" v-show="boatListShow">
                                                <div class="boatBox-top flex">
                                                    <div class="left">
                                                        {{ $t('booking.popover.vesselCode') }}
                                                    </div>
                                                    <div class="right">
                                                        {{ $t('booking.popover.vesselNameCn') }}
                                                    </div>
                                                </div>
                                                <ul>
                                                    <li v-for="(i,j) in boatList" class="flex"
                                                        :key="j"
                                                        @click="checkBoatData(i)">
                                                        <div class="left">{{ i.vesselCode }}</div>
                                                        <div class="right">{{ i.vesselNameCn }}</div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="inputName-left">
                                            <div class="inputName-title-left">
                                                        <span>
                                                            {{ $t('booking.popover.vesselNameCn') }}
                                                        </span>
                                            </div>
                                            <el-input v-model="freightAddDialogSearch.vesselName"
                                                      :placeholder="$t('common.pleaseEnter')"
                                                      clearable/>
                                        </div>
                                        <!--VVL查询按钮-->
                                        <el-button class="popoverInner" size="small" icon="el-icon-search"
                                                   @click="vvlPopoverSearch">
                                            {{ findButton }}
                                        </el-button>
                                    </div>
                                    <div class="flex flex-space-between">
                                        <!--航次查询条件-->
                                        <div class="inputName-left">
                                            <div class="inputName-title-left">
                                                        <span>
                                                            {{ $t('booking.popover.voyageNo') }}
                                                        </span>
                                            </div>
                                            <el-input v-model="freightAddDialogSearch.voyageNo"
                                                      :placeholder="$t('common.pleaseEnter')"
                                                      clearable/>
                                        </div>
                                        <!--航段查询条件-->
                                        <div class="inputName-left">
                                            <div class="inputName-title-left">
                                                        <span>
                                                            {{ $t('booking.popover.voyageLeg') }}
                                                        </span>
                                            </div>
                                            <el-input v-model="freightAddDialogSearch.voyageLeg"
                                                      :placeholder="$t('common.pleaseEnter')"
                                                      clearable/>
                                        </div>
                                        <!--VVL关闭按钮-->
                                        <el-button size="small" class="popoverInner"
                                                   icon="el-icon-warning-outline"
                                                   @click="vvlPopoverClose">
                                            {{ closeButton }}
                                        </el-button>
                                    </div>
                                    <!--船名数据查询表格-->
                                    <el-table :data="tablePopoverVVLInfo" style="width:100%;margin-top:5px"
                                              max-height="300" highlight-current-row
                                              :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                              :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                              :empty-text="$t('common.noData')"
                                              @row-dblclick="vvlPopTableRowDbClick"
                                              @row-click="vvlPopTableRowClick">
                                        <!--序号-->
                                        <el-table-column min-width="60" type="index"
                                                         :label="$t('booking.popover.no')"
                                                         align="center"></el-table-column>
                                        <!--船舶代码-->
                                        <el-table-column min-width="110" prop="vesselCode"
                                                         :label="$t('booking.popover.vesselCode')"
                                                         align="center"></el-table-column>
                                        <!--船名-->
                                        <el-table-column min-width="190" prop="vesselName"
                                                         :label="$t('booking.popover.vessel')"
                                                         align="center"></el-table-column>
                                        <!--船中文名-->
                                        <el-table-column min-width="140" prop="vesselNameCn"
                                                         :label="$t('booking.popover.vesselNameCN')"
                                                         align="center"></el-table-column>
                                        <!--航次-->
                                        <el-table-column min-width="100" prop="voyageNo"
                                                         :label="$t('booking.popover.voyageNo')"
                                                         align="center"></el-table-column>
                                        <!--航段-->
                                        <el-table-column min-width="110" prop="voyageLeg"
                                                         :label="$t('booking.popover.voyageLeg')"
                                                         align="center"></el-table-column>
                                    </el-table>
                                    <div class="flex flex-space-between">
                                        <div class="topMargin flex1">
                                            {{ getTotalDisplay }}
                                        </div>
                                        <!--VVL确认按钮-->
                                        <el-button class="topMargin" type="primary"
                                                   @click="vvlPopoverConfirm">
                                            {{ confirmButton }}
                                        </el-button>
                                        <!--VVL pagination分页条-->
                                        <div class="pagination flex1">
                                            <el-pagination small layout="sizes,pager"
                                                           :page-size="popPageSize"
                                                           :page-sizes="[5, 10]"
                                                           :total="popTotal"
                                                           :pager-count="popPageCount"
                                                           :current-page="popPageNum"
                                                           @size-change="popVVLHandleSizeChange"
                                                           @current-change="popVVLHandleCurrentChange"
                                                           max-height="600"></el-pagination>
                                        </div>
                                    </div>
                                </div>
                                <img slot="reference" style="cursor:pointer" class="voyageIcon"
                                     src="../../../assets/image/voyage.png"/>
                            </el-popover>
                        </el-col>
                    </div>
                </el-col>
                <!--开航日从查询条件-->
                <div class="inputName-left">
                    <div class="inputName-title-left">
                        <span>{{ $t('billsDetails.freightAddDialog.sailingTimeStart') }}</span>
                    </div>
                    <el-date-picker v-model="freightAddDialogSearch.sailingTimeStart" type="date" class="dateInput1"
                                    :placeholder="$t('common.pleaseSelectDate')"
                                    clearable/>
                </div>
                <!--开航日到查询条件-->
                <div class="inputName-left">
                    <div class="inputName-title-left">
                        <span>{{ $t('billsDetails.freightAddDialog.sailingTimeEnd') }}</span>
                    </div>
                    <el-date-picker v-model="freightAddDialogSearch.sailingTimeEnd" type="date" class="dateInput1"
                                    :placeholder="$t('common.pleaseSelectDate')"
                                    clearable/>
                </div>
                <!--添加费用弹框查询按钮-->
                <el-button class="popoverInner" size="small" type="primary" icon="el-icon-search"
                           @click="freightDialogSearchBtnCLick">
                    {{ $t('billsDetails.button.searchBtn') }}
                </el-button>
            </div>
            <div class="flex flex-space-between">
                <el-col :span="7" style="width: 46.4%">
                    <div class="inputName-left">
                        <el-col :span="7" style="width: 33.2%">
                            <!--年份查询条件-->
                            <div class="inputName-left">
                                <div class="inputName-title-left">
                                    <span>{{ $t('billsDetails.freightAddDialog.year') }}</span>
                                </div>
                                <el-select v-model="freightAddDialogSearch.year"
                                           :placeholder="$t('common.pleaseSelect')"
                                           filterable default-first-option>
                                    <el-option v-for="item in yearOptions"
                                               :key="item.label" :label="item.label" :value="item.value">
                                        <span style="float: left">{{ item.label }}</span>
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="7" style="width: 28.6%">
                            <!--月份查询条件-->
                            <div class="inputName-left">
                                <div class="inputName-title-left">
                                    <span>{{ $t('billsDetails.freightAddDialog.month') }}</span>
                                </div>
                                <el-select v-model="freightAddDialogSearch.month"
                                           :placeholder="$t('common.pleaseSelect')"
                                           filterable default-first-option>
                                    <el-option
                                        v-for="item in monthOptions"
                                        :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="7" style="width: 37%">
                            <!--币种查询条件-->
                            <div class="inputName-left">
                                <div class="inputName-title-left">
                                    <span>{{ $t('billsDetails.freightAddDialog.currency') }}</span>
                                </div>
                                <el-select v-model="freightAddDialogSearch.currency" clearable
                                           :placeholder="$t('common.pleaseSelect')"
                                           @focus="currencyCodeFocus">
                                    <el-option
                                        v-for="item in currencyOptions"
                                        :key="item.currencyCode"
                                        :label="item.currencyCode"
                                        :value="item.currencyCode">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </div>
                </el-col>
                <!--提单号查询条件-->
                <div class="inputName-left">
                    <div class="inputName-title-left">
                        <span>{{ $t('confirmFreight.blNo') }}</span>
                    </div>
                    <el-input v-model="freightAddDialogSearch.blNo"
                              :placeholder="$t('common.pleaseEnter')"
                              clearable/>
                </div>
                <!--费项查询条件-->
                <div class="inputName-left">
                    <el-col :span="7" style="width: 90%">
                        <div class="inputName-left">
                            <div class="inputName-title-left">
                                <span>{{ $t('billsDetails.freightAddDialog.chargeCode') }}</span>
                            </div>
                            <el-input v-model="freightAddDialogSearch.chargeCode"
                                      :placeholder="$t('common.pleaseEnter')"
                                      clearable/>
                        </div>
                    </el-col>
                    <el-col :span="7" style="width: 10%; margin-left:-3px">
                        <!--费用查询弹框-->
                        <el-popover ref="chargeCodePopover" class="popover" width="600" trigger="click"
                                    placement="right"
                                    @hide="chargeCodeShow=false">
                            <el-row>
                                <el-col :span="7" style="width: 49%; margin-left: 5px">
                                    <!--费用代码查询条件-->
                                    <div class="inputName-left">
                                        <div class="inputName-title-left">
                                            <span>{{$t('confirmFreight.chargeCode')}}</span>
                                        </div>
                                        <el-input v-model="chargePopoverSearch.chargeCode"
                                                  :placeholder="$t('common.pleaseEnter')"
                                                  clearable/>
                                    </div>
                                </el-col>
                                <el-col :span="7" style="width: 49%; margin-left: 5px">
                                    <!--费用名称查询条件-->
                                    <div class="inputName-left">
                                        <div class="inputName-title-left">
                                            <span>{{$t('confirmFreight.chargeName')}}</span>
                                        </div>
                                        <el-input v-model="chargePopoverSearch.chargeName"
                                                  :placeholder="$t('common.pleaseEnter')"
                                                  clearable/>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 5px">
                                <el-col :span="7" style="width: 49%; margin-left: 5px">
                                    <!--费用名称CN查询条件-->
                                    <div class="inputName-left">
                                        <div class="inputName-title-left">
                                            <span>{{$t('confirmFreight.chargeNameCn')}}</span>
                                        </div>
                                        <el-input v-model="chargePopoverSearch.chargeNameCn"
                                                  :placeholder="$t('common.pleaseEnter')"
                                                  clearable/>
                                    </div>
                                </el-col>
                                <el-col :span="7"
                                        style="width: 49%; margin-left: 5px; text-align: right">
                                    <el-button class="popoverInner" size="small" icon="el-icon-search"
                                               @click="chargeCodePopoverSearch">
                                        {{ findButton }}
                                    </el-button>
                                    <el-button class="popoverInner" size="small"
                                               icon="el-icon-warning-outline"
                                               @click="closeChargeCodePopoverView">
                                        {{ closeButton }}
                                    </el-button>
                                </el-col>
                            </el-row>
                            <!--费用代码数据表格-->
                            <el-table :data="tablePopoverChargeInfo" class="chargeCodePopover"
                                      style="width:100%;margin-top:5px;margin-bottom: 5px"
                                      max-height="350" highlight-current-row
                                      :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                      :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                      :empty-text="$t('common.noData')"
                                      @row-dblclick="chargePopTableRowDbClick"
                                      @row-click="chargePopTableRowClick">
                                <el-table-column width="60" type="index" :label="$t('confirmFreight.no')"></el-table-column>
                                <el-table-column width="80" prop="chargeCode"
                                                 :label="$t('confirmFreight.chargeCode')"></el-table-column>
                                <el-table-column width="230" prop="chargeName"
                                                 :label="$t('confirmFreight.chargeName')"></el-table-column>
                                <el-table-column width="230" prop="chargeNameCn"
                                                 :label="$t('confirmFreight.chargeNameCn')"></el-table-column>
                            </el-table>
                            <div class="flex flex-space-between">
                                <div class="topMargin flex1">
                                    {{ `共${chargePopoverSearch.popTotal}条` }}
                                </div>
                                <el-button class="popoverInner" type="primary"
                                           @click="chargeCodePopoverConfirm">
                                    {{ confirmButton }}
                                </el-button>
                                <div class="pagination flex1">
                                    <el-pagination max-height="600" small layout="sizes,pager"
                                                   :page-size="chargePopoverSearch.popPageSize"
                                                   :total="chargePopoverSearch.popTotal"
                                                   :page-sizes="[10, 20, 30, 40, 50]"
                                                   :pager-count="chargePopoverSearch.popPageCount"
                                                   :current-page="chargePopoverSearch.popPageNum"
                                                   @size-change="popVVLHandleSizeChange"
                                                   @current-change="popVVLHandleCurrentChange">
                                    </el-pagination>
                                </div>
                            </div>
                            <!--包装类型弹框显示按钮-->
                            <img slot="reference" style="cursor:pointer" class="chargeCodeButton"
                                 src="../../../assets/image/selectMore.png"/>
                        </el-popover>
                    </el-col>
                </div>
                <!--添加费用弹框重置按钮-->
                <el-button class="popoverInner" size="small" icon="el-icon-warning-outline"
                           @click="freightDialogResetBtnCLick">
                    {{ $t('common.resetButton') }}
                </el-button>
            </div>
            <el-tabs v-model="addFreightDialogActiveName" @tab-click="handleClick">
                <el-tab-pane :label="$t('confirmFreight.voyageInfo')" name="first">
                    <el-table :data="tableDialogVoyageInfo" ref="tableDialogVoyageInfo"
                              style="width:100%"
                              height="350" max-height="350" highlight-current-row
                              :header-cell-style="{background:'#E9E9E9',height:'36px'}"
                              :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                              :empty-text="$t('common.noData')"
                              @selection-change="handleDialogVoyageInfoChecked">
                        <el-table-column type="selection"
                                         width="45"/>
                        <!--序号-->
                        <el-table-column min-width="50" show-overflow-tooltip type="index"
                                         :label="$t('estimateDetails.estContainerPic.index')" align="center"/>
                        <!--船舶代码-->
                        <el-table-column min-width="100" show-overflow-tooltip
                                         prop="vesselCode"
                                         :label="$t('confirmFreight.vesselCode')" align="center"
                                         sortable/>
                        <!--船舶名称-->
                        <el-table-column min-width="150" show-overflow-tooltip prop="vesselName"
                                         :label="$t('confirmFreight.vesselName')" sortable
                                         align="center"/>
                        <!--航次-->
                        <el-table-column min-width="80" show-overflow-tooltip prop="voyageNo"
                                         :label="$t('confirmFreight.voyageNo')" sortable
                                         align="center"/>
                        <!--航段-->
                        <el-table-column min-width="80" show-overflow-tooltip prop="voyageLeg"
                                         :label="$t('confirmFreight.voyageLeg')" sortable
                                         align="center"/>
                        <!--开航时间-->
                        <el-table-column min-width="120" show-overflow-tooltip prop="saillingDate"
                                         :label="$t('confirmFreight.saillingDate')" sortable
                                         align="center"/>
                        <!--总金额-->
                        <el-table-column min-width="200" show-overflow-tooltip prop="amountTotal"
                                         :label="$t('confirmFreight.amountTotal')" sortable
                                         align="left"/>
                    </el-table>
                    <!--航次功能按钮-->
                    <div style="margin-bottom: 5px;margin-top: 5px">
                        <!--全选-->
                        <el-button type="text" icon="el-icon-my-selectAll" plain size="mini"
                                   @click="freightDialogCheckAllBtnClick(true)">
                            {{ selectAll }}
                        </el-button>
                        <!--反选-->
                        <el-button type="text" icon="el-icon-my-selectInverse" plain size="mini"
                                   @click="freightDialogCheckAllBtnClick(false)">
                            {{ selectInverse }}
                        </el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="this.$t('confirmFreight.freightInfo')" name="second">
                    <div>
                        <el-table :data="tableDialogFreightInfo" ref="tableDialogFreightInfo"
                                  style="width:100%" :row-style="{height:'40px'}" :cell-style="{padding:'0px'}"
                                  height="328" max-height="328" highlight-current-row
                                  :header-cell-style="{background:'#E9E9E9',height:'36px'}"
                                  :empty-text="$t('common.noData')"
                                  @selection-change="handleDialogFreightInfoChecked">
                            <el-table-column prop="checked"
                                             type="selection"
                                             width="45"/>
                            <!--序号-->
                            <el-table-column min-width="50" show-overflow-tooltip type="index"
                                             :label="$t('estimateDetails.estContainerPic.index')" align="center"/>
                            <!--船舶代码-->
                            <el-table-column min-width="120" show-overflow-tooltip prop="vesselCode"
                                             :label="$t('confirmFreight.vesselCode')" sortable
                                             align="center"/>
                            <!--船舶名称-->
                            <el-table-column min-width="220" show-overflow-tooltip prop="vesselName"
                                             :label="$t('confirmFreight.vesselName')" sortable
                                             align="center"/>
                            <!--航次-->
                            <el-table-column min-width="120" show-overflow-tooltip prop="voyageNo"
                                             :label="$t('confirmFreight.voyageNo')" sortable
                                             align="center"/>
                            <!--航段-->
                            <el-table-column min-width="120" show-overflow-tooltip prop="voyageLeg"
                                             :label="$t('confirmFreight.voyageLeg')" sortable
                                             align="center"/>
                            <!--开航时间-->
                            <el-table-column min-width="130" show-overflow-tooltip prop="saillingDate"
                                             :label="$t('confirmFreight.saillingDate')" sortable
                                             align="center"/>
                            <!--提单号-->
                            <el-table-column min-width="180" show-overflow-tooltip prop="blNo"
                                             :label="$t('confirmFreight.blNo')" sortable
                                             align="center"/>
                            <!--费项代码-->
                            <el-table-column min-width="130" show-overflow-tooltip prop="chargeCode"
                                             :label="$t('confirmFreight.chargeCode')" sortable
                                             align="center"/>
<!--                            &lt;!&ndash;费项名称&ndash;&gt;-->
<!--                            <el-table-column min-width="150" show-overflow-tooltip prop="chargeName"-->
<!--                                             :label="$t('confirmFreight.chargeName')" sortable-->
<!--                                             align="center">-->
<!--                                <template slot-scope="scope">-->
<!--                                    <span>{{ getChargeNameDisplayValue(scope.row) }}</span>-->
<!--                                </template>-->
<!--                            </el-table-column>-->
                            <!--计价数量-->
                            <el-table-column min-width="130" show-overflow-tooltip prop="caculateQty"
                                             :label="$t('confirmFreight.caculateQty')" sortable
                                             align="center"/>
<!--                            &lt;!&ndash;计价单位&ndash;&gt;-->
<!--                            <el-table-column min-width="130" show-overflow-tooltip prop="caculateUnit"-->
<!--                                             :label="$t('confirmFreight.caculateUnit')" sortable-->
<!--                                             align="center"/>-->
                            <!--币种-->
                            <el-table-column min-width="110" show-overflow-tooltip prop="currency"
                                             :label="$t('confirmFreight.currency')" sortable
                                             align="center"/>
                            <!--应收金额-->
                            <el-table-column min-width="120" show-overflow-tooltip prop="amount"
                                             :label="$t('confirmFreight.amount')" sortable
                                             align="center"/>
                            <!--应收客户代码-->
                            <el-table-column min-width="150" show-overflow-tooltip prop="payer"
                                             :label="$t('confirmFreight.payer')" sortable
                                             align="center"/>
<!--                            &lt;!&ndash;应收客户名称&ndash;&gt;-->
<!--                            <el-table-column min-width="220" show-overflow-tooltip prop="payerName"-->
<!--                                             :label="$t('confirmFreight.customerName')" sortable-->
<!--                                             align="center"/>-->
                            <!--应收客户名称(CN)-->
                            <el-table-column min-width="220" show-overflow-tooltip prop="payerNameCn"
                                             :label="$t('confirmFreight.customerNameCn')" sortable
                                             align="center"/>
<!--                            &lt;!&ndash;付费方式&ndash;&gt;-->
<!--                            <el-table-column min-width="110" show-overflow-tooltip prop="payModel"-->
<!--                                             :label="$t('confirmFreight.payModel')" sortable-->
<!--                                             align="center"/>-->
                        </el-table>
                    </div>
                    <!--费用功能按钮-->
                    <div class="cardTitle flex flex-space-between" style="margin-bottom: 5px;margin-top: 5px">
                        <div>
                            <!--全选-->
                            <el-button type="text" icon="el-icon-my-selectAll" plain size="mini"
                                       @click="freightDialogCheckAllBtnClick(true)">
                                {{ selectAll }}
                            </el-button>
                            <!--反选-->
                            <el-button type="text" icon="el-icon-my-selectInverse" plain size="mini"
                                       @click="freightDialogCheckAllBtnClick(false)">
                                {{ selectInverse }}
                            </el-button>
                        </div>
                        <!--费用数据表格pagination分页条-->
                        <div class="pagination">
                            <div>
                                <el-pagination background layout="total,sizes,slot,prev, pager, next"
                                               max-height="600"
                                               :page-size="this.freightAddDialogSearch.popPageSize" :pager-count="this.freightAddDialogSearch.popPageCount"
                                               :page-sizes="[1000, 2000, 5000, 10000]" :total="this.freightAddDialogSearch.popTotal"
                                               :current-page="this.freightAddDialogSearch.popPageNum"
                                               @size-change="popFreightHandleSizeChange"
                                               @current-change="popFreightHandleCurrentChange"/>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div style="text-align: center">
                <!--确认-->
                <el-button type="primary"
                           @click="freightDialogConfirmBtnClick">
                    {{ $t('common.confirmButton') }}
                </el-button>
                <!--关闭-->
                <el-button type="primary" plain
                           @click="freightDialogCloseBtnClick">
                    {{ $t('common.closeButton') }}
                </el-button>
            </div>
        </el-dialog>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'invoiceDetails',
    computed: {
        /************************************ 页面按钮国际化信息 ***********************************/
        //返回按钮
        returnButton() {
            return this.$t("common.returnButton");
        },
        findButton() {//搜索按钮
            return this.$t("common.findButton");
        },
        closeButton() {//关闭按钮
            return this.$t("common.closeButton");
        },
        confirmButton() {//确认按钮
            return this.$t("common.confirmButton");
        },
        selectAll() {//全选
            return this.$t("common.selectAll");
        },
        selectInverse() {//反选
            return this.$t("common.selectInverse");
        },
        getTotalDisplay() {
            return this.$t("common.total").replace("?", this.popTotal);
        },
        // 当对账单为已确认状态时，对账单内容为只读
        getReadOnlyFlag() {
            return this.statementOfAccount == null
                || (this.statementOfAccount.confirmFlag != null && this.statementOfAccount.confirmFlag == 1);
        },
        // 对账单为新增对账单，或确认状态为空/未确认/取消确认状态时，保存按钮可用(true)
        getSaveBtnStatus() {
            return this.statementOfAccount != null
                && (this.statementOfAccount.confirmFlag == null || this.statementOfAccount.confirmFlag != 1);
        },
        // 对账单非新增对账单并且确认状态为空/未确认/取消确认状态时，确认按钮可用(true)
        getConfirmBtnStatus() {
            return this.statementOfAccount != null
                && this.statementOfAccount.statementOfAccountId != null
                && (this.statementOfAccount.confirmFlag == null || this.statementOfAccount.confirmFlag != 1)
        },
        // 对账单非新增对账单并且确认状态为已确认、开票状态为未开票，取消确认按钮可用(true)
        getCancelConfirmBtnStatus() {
            return this.statementOfAccount != null
                && this.statementOfAccount.statementOfAccountId != null
                && this.statementOfAccount.confirmFlag != null
                && this.statementOfAccount.confirmFlag == 1
                && (this.statementOfAccount.invoiceFlag == null
                    || this.statementOfAccount.invoiceFlag == 0
                    || this.statementOfAccount.invoiceFlag == 1)
        },
        // 对账单非新增对账单并且确认状态为空/未确认/取消确认状态时，删除按钮可用(true)
        getDeleteBtnStatus() {
            return this.statementOfAccount != null
                && this.statementOfAccount.statementOfAccountId != null
                && (this.statementOfAccount.confirmFlag == null || this.statementOfAccount.confirmFlag != 1)
        },
        // 对账单非新增对账单并且确认状态为已确认、开票状态为未开票，申请开票按钮可用(true)
        getInvoiceBtnStatus() {
            return this.statementOfAccount != null
                && this.statementOfAccount.statementOfAccountId != null
                && this.statementOfAccount.confirmFlag != null
                && this.statementOfAccount.confirmFlag == 1
                && (this.statementOfAccount.invoiceFlag == null
                    || this.statementOfAccount.invoiceFlag == 0
                    || this.statementOfAccount.invoiceFlag == 1)
        },
    },
    data() {
        return {
            activeName: 'first',// 默认选中第一个tab页
            addFreightDialogActiveName: 'first',// 添加费用弹窗默认选中第一个tab页
            allAlign: 'center',// vxe-table表格默认文字居中

            isSaveClick: false,         // 控制保存按钮点击频率
            isSearchClick: false,       //控制查询按钮是否重复点击
            boatListShow: false,        //控制船舶查询弹框是否显示
            freightAddDialogShow: false,    //控制添加费用弹框是否展示

            confirmStatusOptions: [     // 确认状态
                {codeValue: 0, displayValueCn: "未确认", displayValue: "UNCONFIRMED"},
                {codeValue: 1, displayValueCn: "已确认", displayValue: "CONFIRMED"},
                {codeValue: 2, displayValueCn: "取消确认", displayValue: "CANCEL CONFIRMED"},
            ],
            invoiceStatusOptions: [// 开票状态
                {codeValue: 0, displayValueCn: " ", displayValue: " "},
                {codeValue: 1, displayValueCn: "未开票", displayValue: "UNINVOICED"},
                {codeValue: 2, displayValueCn: "部分开票", displayValue: "PARTIAL INVOICED"},
                {codeValue: 3, displayValueCn: "已开票", displayValue: "INVOICED"},

            ],
            yearOptions: [],               //年份下拉选
            monthOptions: [],              //月份下拉选
            currencyOptions: [],
            cargoTypeOptions: [],           //货物类型下拉选项

            //费用弹框查询参数
            chargePopoverSearch: {
                chargeCode: "",
                chargeName: "",
                chargeNameCn: "",
                popTableSelection: [],
                popTotal: 0,
                popPageCount: 5,
                popPageNum: 1,
                popPageSize: 5,
            },
            //添加费用弹框查询参数
            freightAddDialogSearch: {
                vesselCode: "",
                voyageNo: "",
                voyageLeg: "",
                sailingTimeStart: "",
                sailingTimeEnd: "",
                blNo: "",
                year: "",
                month: "",
                chargeCode: "",
                currency: "",
                // 添加费用弹框分页参数
                popPageCount: 5,
                popPageNum: 1,
                popPageSize: 1000,
                popTotal: 0,
            },
            // 船名/航次弹框分页参数
            popPageCount: 5,
            popPageNum: 1,
            popPageSize: 5,
            popTotal: 0,

            // 对账单数据
            statementOfAccount: {
                statementOfAccountId: "",// 对账单ID
                soaNo: "",// 对账单号
                balanceUnits: "",// 结算单位代码
                balanceUnitsEn: "",// 结算单位名称
                balanceUnitsCn: "",// 结算单位名称(CN)
                officeCode: "",// 所属组织
                createdByUser: "",// 创建人
                createdDtmLoc: "",// 创建时间
                confirmFlag: null,//确认状态
                invoiceFlag: null,// 开票状态
                remark: "",// 备注
                transformFlag: null//结转财务标志
            },
            // 【应收金额表格数据】
            tableCurrencyAmountInfo: [],
            // 【航次表格数据】
            tableVoyageInfo: [],
            tableVoyageInfoChecked: [],//航次表格数据多选列表
            // 【提单表格数据】
            tableBLNoInfo: [],
            tableBLNoInfoChecked: [],//提单表格数据多选列表
            // 【费用表格数据】
            tableFreightReceivableInfo: [],
            tableFreightReceivableInfoChecked: [],//费用表格数据多选列表
            tableFreightReceivableInfoDeleted: [],//待删除的费用明细列表
            // 船名航次弹框 【船名航次数据】
            boatList: [],
            tablePopoverVVLInfo: [],
            tablePopoverVVLSelection: [],   //船名航次弹框中表格当前点击选中数据
            //费用查询弹框 【费用代码数据】
            tablePopoverChargeInfo: [],
            tablePopoverChargeSelection: [], //费用弹框中表格当前点击选中数据
            // 添加费用弹框 【航次数据】
            tableDialogVoyageInfo: [],
            tableDialogVoyageInfoChecked: [],//添加费用弹框 航次表格多选列表
            // 添加费用弹框 【费用明细数据】
            tableDialogFreightInfo: [],
            tableDialogFreightInfoChecked: [],//添加费用弹框费用明细表格多选列表、
        }
    },
    methods: {
        /************************************ 工具栏按钮点击事件 *************************************/
        /**
         * 页面底部全选/反选按钮点击
         */
        checkAllBtnClick(isCheck) {
            this.tableVoyageInfoChecked = [];
            this.tableBLNoInfoChecked = [];
            this.tableFreightReceivableInfoChecked = [];
            // 航次信息全选/反选
            this.tableVoyageInfo.forEach((item, index) => {
                this.tableVoyageCheckOneMethod(index, isCheck)
            });
            // 提单信息全选/反选
            this.tableBLNoInfo.forEach((item, index) => {
                this.tableBlCheckOneMethod(index, isCheck)
            });
            // 费用信息全选/反选
            this.tableFreightReceivableInfo.forEach((item, index) => {
                this.tableFreightCheckOneMethod(index, isCheck)
            })
        },
        tableVoyageCheckOneMethod(index, type) {
            let curData = this.tableVoyageInfo[index];
            if (type) {//选中
                this.tableVoyageInfoChecked.push(curData);
                this.$refs.tableVoyageInfo.setCheckboxRow(curData, type);
            } else {//取消选中
                this.tableVoyageInfoChecked.forEach((item, index) => {
                    if (item.bkFreightReceiveId === curData.bkFreightReceiveId) {
                        this.tableVoyageInfoChecked.splice(index, 1);
                    }
                });
                this.$refs.tableVoyageInfo.toggleCheckboxRow(curData);
            }
        },
        tableBlCheckOneMethod(index, type) {
            let curData = this.tableBLNoInfo[index];
            if (type) {//选中
                this.tableBLNoInfoChecked.push(curData);
                this.$refs.tableBLNoInfo.setCheckboxRow(curData, type);
            } else {//取消选中
                this.tableBLNoInfoChecked.forEach((item, index) => {
                    if (item.blNo === curData.blNo) {
                        this.tableBLNoInfoChecked.splice(index, 1);
                    }
                });
                this.$refs.tableBLNoInfo.toggleCheckboxRow(curData);
            }
        },
        tableFreightCheckOneMethod(index, type) {
            let curData = this.tableFreightReceivableInfo[index];
            if (type) {//选中
                this.tableFreightReceivableInfoChecked.push(curData);
                this.$refs.tableFreightReceivableInfo.setCheckboxRow(curData, type);
            } else {//取消选中
                this.tableFreightReceivableInfoChecked.forEach((item, index) => {
                    if (item.bkFreightReceiveId === curData.bkFreightReceiveId) {
                        this.$refs.tableFreightReceivableInfo.toggleCheckboxRow(item);
                        this.tableFreightReceivableInfoChecked.splice(index, 1);
                    }
                });
            }
        },
        tableFreightCancelCheckedMethod(index) {
            let curData = this.tableFreightReceivableInfo[index];
            this.tableFreightReceivableInfoChecked.forEach((item, index) => {
                if (item.bkFreightReceiveId === curData.bkFreightReceiveId) {
                    this.tableFreightReceivableInfoChecked.splice(index, 1);
                }
            });
            // this.$refs.tableFreightReceivableInfo.toggleRowSelection(curData, false);
            this.$refs.tableFreightReceivableInfo.toggleCheckboxRow(curData,false);
        },
        /**
         * 添加费用按钮点击
         */
        addCostBtnClick() {
            this.resetFreightDialogData();
            // 打开添加费用弹框
            this.freightAddDialogShow = true;
        },
        /**
         * 移除费用按钮点击
         */
        removeCostBtnClick() {
            if (this.tableFreightReceivableInfo.length === 0) {
                return;
            }
            if (this.tableFreightReceivableInfoChecked.length <= 0) {
                this.showMessage(false, this.$t('billsManagement.message.noDetails'), "warning");
                return;
            }

            this.$confirm( this.$t('billsManagement.message.removeExpense'), this.$t("common.pleaseConfirm"), {
                distinguishCancelAndClose: true,
                confirmButtonText: this.$t("common.confirmButton"),
                cancelButtonText: this.$t("common.cancelButton")
            }).then(() => {
                // 删除
                this.tableFreightReceivableInfoChecked.forEach((itemChecked) => {
                    this.tableFreightReceivableInfo.forEach((item, index) => {
                        if (item.bkFreightReceiveId == itemChecked.bkFreightReceiveId) {
                            if (item.soaDetailId == null || item.soaDetailId === "") {
                                //新增的费用明细，直接在表格中移除
                                this.tableFreightReceivableInfo.splice(index, 1);
                            } else {
                                //若非新增费用明细，则将该条记录加入到待删除费用明细数组中，再从表格中移除
                                this.tableFreightReceivableInfoDeleted.push(itemChecked);
                                this.tableFreightReceivableInfo.splice(index, 1);
                            }
                        }
                    });
                });

                // 费用移除完成后，刷新对账单费用明细汇总表格
                this.setFreightTotalTableData();
            }).catch(action => {
                //取消
                if (action === 'cancel') {
                    console.log(action);
                }
            })
        },
        /**
         * 保存按钮点击
         */
        returnSave() {
            if (this.isSaveClick) {//上一次请求未结束不能再次发起请求
                return;
            }
            this.relatedSoaNos = [];
            this.isSaveClick = true;
            const condition = this.returnCondition();
            console.log(condition);

            //调用后端对账单保存校验接口
            this.axios({
                method: 'post',
                url: '/api/statementOfAccount/statementOfAccountSaveValidate',
                data: condition,
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    //校验通过，调用后端对账单保存接口
                    this.axios({
                        method: 'post',
                        url: '/api/statementOfAccount/statementOfAccountSave',
                        data: condition,
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            // 获取保存成功生成的对账单数据
                            let soas = response.data.object;
                            if(soas != null && soas.length > 0){
                                // 获取对账单号
                                soas.forEach((soa)=>{
                                    if(soa.soaNo != null && soa.soaNo !== ""){
                                        this.relatedSoaNos.push(soa.soaNo);
                                    }
                                });
                                // 页面对账单数据重新赋值
                                this.setFieldValue(soas[0]);
                            }
                            this.$confirm(this.$t("billsDetails.produceBill") + "{"+this.relatedSoaNos.join(',')+"}", this.$t('billsManagement.message.savedSuccessfully'), {
                                distinguishCancelAndClose: true,
                                confirmButtonText: this.$t("billsDetails.copyBillNo"),
                                cancelButtonText: this.$t("common.close")
                            }).then(() => {
                                this.clickCopy(this.relatedSoaNos.join(','))
                            }).catch(action => {
                                //取消
                                if (action === 'cancel') {
                                    console.log(action);
                                }
                            })
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                        this.isSaveClick = false;
                    }).catch(error => {
                        this.isSaveClick = false;
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                } else {
                    this.showMessage(false, this.responseCode, "error");
                    this.$alert(this.responseCode, this.$t('billsManagement.message.saveFailed'), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                }
                this.isSaveClick = false;
            }).catch(error => {
                this.isSaveClick = false;
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        clickCopy(msg) {
            this.$copyText(msg).then(
                e=>{
                    this.$message({ message: this.$t("message.copyBill"), type: 'success' })
                },
                e=>{
                    this.$message({ message: this.$t("message.copyBillFailed"), type: 'error' })
                }
            )
        },
        /**
         *  获取当前页面对账单数据 公共方法
         */
        returnCondition() {
            let condition = this.statementOfAccount;
            condition.soaDetails = [];

            // 【设置费用明细数据】
            this.tableFreightReceivableInfo.forEach((item)=>{
                condition.soaDetails.push(item);
            });
            // 添加待删除费用明细数据
            if (this.tableFreightReceivableInfoDeleted.length > 0) {
                this.tableFreightReceivableInfoDeleted.forEach((deleteItem) => {
                    deleteItem.rowStatus = 8;//设置为待删除状态
                    condition.soaDetails.push(deleteItem);
                })
            }
            return condition;
        },
        /**
         * 账单确认按钮点击
         */
        returnConfirm() {
            // 校验当前对账单确认状态是否已经为“确认”状态（1L），已确认的不能重复确认
            if (this.statementOfAccount.confirmFlag != null && this.statementOfAccount.confirmFlag == 1) {
                this.$alert(this.$t('billsManagement.message.cannotConfirmAgain'), this.$t("common.tips"), {
                    confirmButtonText: this.$t("common.okButton")
                });
                return;
            }

            // 获取对账单ID
            let statementOfAccountIds=[];
            statementOfAccountIds.push(this.statementOfAccount.statementOfAccountId);

            // 调用后端对账单确认接口
            this.axios({
                method: 'post',
                url: '/api/statementOfAccount/statementOfAccountConfirm',
                data: {
                    statementOfAccountIds: JSON.stringify(statementOfAccountIds),
                },
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.showMessage(true, this.$t('billsManagement.message.confirmSuccess'), "success");
                    this.statementOfAccount.confirmFlag = 1;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        /**
         * 取消确认按钮点击
         */
        returnCancelConfirm() {
            // 校验当前对账单确认状态是否为“已确认”状态（1L）
            if (1!=this.statementOfAccount.confirmFlag ) {
                this.$alert(this.$t('billsManagement.message.cannotCancelConfirm'), this.$t("common.tips"), {
                    confirmButtonText: this.$t("common.okButton")
                });
                return;
            }
            var statementOfAccountIds=[];
            statementOfAccountIds.push(this.statementOfAccount.statementOfAccountId);
            this.axios({
                method: 'post',
                url: '/api/statementOfAccount/statementOfAccountCancelConfirm',
                data: {
                    statementOfAccountIds: JSON.stringify(statementOfAccountIds),
                },
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.showMessage(true, this.responseCode, "success");
                    this.statementOfAccount.confirmFlag = 0;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        /**
         * 申请开票按钮点击
         */
        returnInvoice() {
            // 校验当前对账单确认状态是否为“已确认”状态（1L）
            if (this.statementOfAccount.confirmFlag != 1) {
                this.$alert(this.$t('billsManagement.message.cannotInvoice'), this.$t("common.tips"), {
                    confirmButtonText: this.$t("common.okButton")
                });
                return;
            }

            // 开票操作确认
            this.$confirm(this.$t('billsManagement.message.invoice'), this.$t("common.pleaseConfirm"), {
                distinguishCancelAndClose: true,
                confirmButtonText: this.$t("common.confirmButton"),
                cancelButtonText: this.$t("common.cancelButton")
            }).then(() => {
                // 生成发票内容并打开发票明细页面
                this.transferToInvoiceDetails(this.statementOfAccount);
            });
        },
        transferToInvoiceDetails(statementOfAccount) {
            let statementOfAccountIds = [];
            // 声明一个loading对象
            this.loadingtuo = this.$loading({
                lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                text: this.$t('billsManagement.message.generatingInvoice'),             // 加载动画的文字
                spinner: 'el-icon-loading',                     // 引入的loading图标
                background: "rgb(0,0,0,0.1)",
            });
            let that = this;

            statementOfAccountIds.push(statementOfAccount.statementOfAccountId);
            // 对账单开票前校验
            this.axios({
                method: 'post',
                url: '/api/invoiceDoc/transferToInvoice',
                data: {
                    statementOfAccountIds: JSON.stringify(statementOfAccountIds),
                },
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {//检验成功
                    // 获取对账单生成的发票内容
                    let invoiceDocInfo = response.data.object;
                    let statementOfAccounts = [];
                    statementOfAccounts.push(statementOfAccount);
                    // 跳转到发票明细页面
                    setTimeout(() => {
                        // 关闭加载中显示
                        that.loadingtuo.close();
                        // 跳转到发票明细编辑页面
                        // this.$router.push({
                        //     name: 'invoiceDetails',
                        //     params: {
                        //         invoiceDocInfo: invoiceDocInfo,
                        //         statementOfAccounts: statementOfAccounts
                        //     }
                        // });
                        var route = this.$router.resolve({
                            name: 'invoiceDetails',
                        });
                        // 将传递参数存到session中
                        sessionStorage.setItem("PASSING_PARAMETERS", JSON.stringify(invoiceDocInfo));
                        sessionStorage.setItem("PASSING_PARAMETERS_1", JSON.stringify(statementOfAccounts));
                        // 打开对账单明细页面
                        window.open(route.href, '_blank')
                    }, 1200);
                } else {//校验失败，提示校验失败信息
                    that.loadingtuo.close();
                    this.responseCode = response.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                that.loadingtuo.close();
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        /**
         * 删除按钮点击
         */
        returnDelete() {
            // 校验确认状态是否为未确认状态
            if (this.statementOfAccount.confirmFlag!=null&&this.statementOfAccount.confirmFlag == 1) {
                this.$alert(this.$t('billsManagement.message.cannotDeleted'), this.$t('billsManagement.message.deleteFailed'), {
                    confirmButtonText: this.$t("common.okButton")
                });
                return;
            }
            this.$confirm(this.$t('billsManagement.message.deleteSOA'), this.$t("common.pleaseConfirm"), {
                distinguishCancelAndClose: true,
                confirmButtonText: this.$t("common.deleteButton"),
                cancelButtonText: this.$t("common.cancelButton")
            }).then(() => {
                var statementOfAccountIds=[];
                statementOfAccountIds.push(this.statementOfAccount.statementOfAccountId);
                this.axios({
                    method: 'post',
                    url: '/api/statementOfAccount/statementOfAccountDel',
                    data: {
                        statementOfAccountIds: JSON.stringify(statementOfAccountIds),
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showMessage(true, this.responseCode, "success");
                        this.$router.back(-1);
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
                // this.showMessage(false, "删除成功！", "success");
            })
        },
        /**
         * 对账单下载按钮点击
         */
        billsDownload(type) {
            // TODO 对账单下载
            switch (type) {
                case "PDF":
                    this.showMessage(false, this.$t("billsDetails.pdfDownLoad"), "success");
                    break;
                case "EXCEL":
                    this.showMessage(false, this.$t("billsDetails.excelDownLoad"), "success");
                    break;
            }
        },

        /************************************ 页面表格多选事件 *************************************/
        /**
         * 航次信息表格勾选事件（将该航次下的费用信息同时勾选/取消勾选）
         */
        handleVoyageInfoChecked(checked) {
            // 更新表格勾选的航次信息
            this.tableVoyageInfoChecked = this.$refs.tableVoyageInfo.getCheckboxRecords();
            // 获取选中的船名航次
            let vvlMap = new Map();
            this.tableVoyageInfoChecked.forEach((item) => {
                vvlMap.set(item.vesselCode + item.voyageNo + item.voyageLeg, 1)
            });
            // 遍历费用信息表格，将属于该航次下的全部费用都自动勾选上
            let vvlList = [];
            for (let item of vvlMap.keys()) {
                vvlList.push(item);
            }
            this.tableFreightReceivableInfo.forEach((freight, index) => {
                if (vvlList.includes(freight.vesselCode + freight.voyageNo + freight.voyageLeg)) {
                    if(checked){
                        // 设置费用选中
                        this.tableFreightReceivableInfoChecked.push(freight);
                        this.$refs.tableFreightReceivableInfo.setCheckboxRow(freight, true);
                    } else{
                        // 设置费用取消选中
                        this.tableFreightReceivableInfoChecked.forEach((item, index) => {
                            if (item.bkFreightReceiveId === freight.bkFreightReceiveId) {
                                this.$refs.tableFreightReceivableInfo.toggleCheckboxRow(freight);
                                this.tableFreightReceivableInfoChecked.splice(index, 1);
                            }
                        });
                    }
                } else {
                    // 设置费用取消选中
                    this.tableFreightReceivableInfoChecked.forEach((item, index) => {
                        if (item.bkFreightReceiveId === freight.bkFreightReceiveId) {
                            this.$refs.tableFreightReceivableInfo.setCheckboxRow(freight, false);
                            this.tableFreightReceivableInfoChecked.splice(index, 1);
                        }
                    });
                }
            })
        },
        /**
         * 重写航次表格行勾选事件
         */
        selectVVLChangeEvent(row) {
            this.$refs.tableVoyageInfo.setCheckboxRow(row, row.checked);
            this.handleVoyageInfoChecked(row.checked);
        },
        /**
         * 提单信息表格勾选事件（将该提单的全部费用信息同时勾选/取消勾选）
         */
        handleBLNoInfoChecked(checked) {
            // 获取提单表格勾选的提单信息
            this.tableBLNoInfoChecked = this.$refs.tableBLNoInfo.getCheckboxRecords();
            let blNoList = [];
            // 获取当前勾选的提单号
            this.tableBLNoInfoChecked.forEach((blNo) => {
                blNoList.push(blNo.blNo)
            });
            console.log("勾选的提单信息",blNoList);
            // 自动选中对应的费用信息
            this.tableFreightReceivableInfo.forEach((freight, index) => {
                if (blNoList.includes(freight.blNo)) {
                    if(checked){
                        // 设置费用选中
                        this.tableFreightReceivableInfoChecked.push(freight);
                        this.$refs.tableFreightReceivableInfo.setCheckboxRow(freight, true);
                    } else{
                        // 设置费用取消选中
                        this.tableFreightReceivableInfoChecked.forEach((item, index) => {
                            if (item.bkFreightReceiveId === freight.bkFreightReceiveId) {
                                this.$refs.tableFreightReceivableInfo.toggleCheckboxRow(freight);
                                this.tableFreightReceivableInfoChecked.splice(index, 1);
                            }
                        });
                    }
                } else{
                    // 设置费用取消选中
                    this.tableFreightReceivableInfoChecked.forEach((item, index) => {
                        if (item.bkFreightReceiveId === freight.bkFreightReceiveId) {
                            this.$refs.tableFreightReceivableInfo.setCheckboxRow(freight, false);
                            this.tableFreightReceivableInfoChecked.splice(index, 1);
                        }
                    });
                }
            })
        },
        /**
         * 重写提单表格行勾选事件
         */
        selectBlNoChangeEvent(row) {
            // 更新当前行提单选中状态
            this.$refs.tableBLNoInfo.setCheckboxRow(row, row.checked);
            // 根据选中提单，勾选费用信息
            this.handleBLNoInfoChecked(row.checked);
        },
        /**
         * 判断提单号是否为半选状态
         */
        ifBlNoIndeterminate(row) {
            let allChecked = true;
            let checkedRecords = this.$refs.tableFreightReceivableInfo.getCheckboxRecords();
            let count = 0;
            this.tableFreightReceivableInfo.forEach((freight) => {
                if (freight.blNo === row.blNo) {
                    if(!checkedRecords.includes(freight)){
                        allChecked = false;
                    } else{
                        // 记录当前提单号对应选中费用的条数
                        count += 1;
                    }
                }
            });

            if(count === 0){
                row.checked = false;
                return false;
            } else if(allChecked){
                row.checked = true;
                return false;
            }else{
                return true;
            }
        },
        /**
         * 判断船名航次是否为半选状态
         */
        ifVVLIndeterminate(row) {
            let allChecked = true;
            let checkedRecords = this.$refs.tableFreightReceivableInfo.getCheckboxRecords();
            let count = 0;
            this.tableFreightReceivableInfo.forEach((freight) => {
                if (freight.vesselCode === row.vesselCode
                    && freight.voyageNo === row.voyageNo
                    && freight.voyageLeg === row.voyageLeg) {
                    if(!checkedRecords.includes(freight)){
                        allChecked = false;
                    } else{
                        // 记录当前航次对应选中费用的条数
                        count = count + 1;
                    }
                }
            });

            if(count === 0){
                // 全部未勾选
                row.checked = false;
                return false;
            } else if(allChecked){
                // 全部勾选
                row.checked = true;
                return false;
            }else{
                return true;
            }
        },
        /**
         * 费用信息表格勾选事件
         */
        handleFreightReceivableInfoChecked({ checked }) {
            console.log("handleFreightReceivableInfoChecked");
            // 更新费用信息多选列表
            this.tableFreightReceivableInfoChecked = this.$refs.tableFreightReceivableInfo.getCheckboxRecords();
            // 更新提单号表格选中状态
            this.$refs.tableBLNoInfo.loadData(this.tableBLNoInfo);
            // 更新航次信息表格选中状态
            this.$refs.tableVoyageInfo.loadData(this.tableVoyageInfo);
        },

        /************************************ 添加费用弹框表格多选事件 *************************************/
        /**
         * 航次数据表格勾选事件（该航次下的提单信息及费用信息同时勾选/取消勾选）
         */
        handleDialogVoyageInfoChecked(val) {
            // 更新表格勾选的航次信息
            this.tableDialogVoyageInfoChecked = val;
            let vvlMap = new Map();
            this.tableDialogVoyageInfoChecked.forEach((item) => {
                if(item){
                    vvlMap.set(item.vesselCode + item.voyageNo + item.voyageLeg, 1)
                }
            });
            // 遍历费用信息表格，将属于该航次下的全部费用都自动勾选上
            let vvlList = [];
            for (let item of vvlMap.keys()) {
                vvlList.push(item);
            }
            this.tableDialogFreightInfo.forEach((freight, index) => {
                if (vvlList.includes(freight.vesselCode + freight.voyageNo + freight.voyageLeg)) {
                    this.tableDialogFreightCheckOneMethod(index, true);
                } else {
                    this.tableDialogFreightCancelCheckedMethod(index);
                }
            })
        },
        /**
         * 费用信息表格勾选事件
         */
        handleDialogFreightInfoChecked(val) {
            // 更新表格勾选的费用信息
            this.tableDialogFreightInfoChecked = val;
        },

        /************************************ 船名航次弹出框 ************************************/
        /**
         * 船名下拉选赋值
         */
        showVesselList() {
            this.boatListShow = true;
            this.axios({
                method: 'get',
                url: '/api/codedict/getVesselList',
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.boatList = response.data.object;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        /**
         *
         * 船名下拉表格数据点击事件
         */
        checkBoatData(boat) {
            this.freightAddDialogSearch.vesselCode = boat.vesselCode;
            this.freightAddDialogSearch.vesselName = boat.vesselName;
            this.boatListShow = false
        },
        /**
         * 搜索按钮点击事件
         */
        vvlPopoverSearch() {
            if (this.isVVLSearchClick) {
                return;
            }
            this.isVVLSearchClick = true;
            this.axios({
                method: 'post',
                url: '/api/voyagePlan/getVVLEntity',
                data: {
                    voyageNo: this.freightAddDialogSearch.voyageNo,
                    voyageLeg: this.freightAddDialogSearch.voyageLeg,
                    vesselName: this.freightAddDialogSearch.vesselName,
                    vesselCode: this.freightAddDialogSearch.vesselCode,
                    pageNum: this.popPageNum,
                    pageSize: this.popPageSize
                },
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.tablePopoverVVLInfo = response.data.object.list;
                    this.popTotal = response.data.object.total;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
                this.isVVLSearchClick = false;
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
                this.isVVLSearchClick = false;
            });
            //每次查询结束清空tablePopoverVVLSelection
            this.tablePopoverVVLSelection = [];
        },
        /**
         * 确认按钮点击事件
         */
        vvlPopoverConfirm() {
            // 赋值选中记录的船名和航次到VVL查询输入框中
            if (this.tablePopoverVVLSelection.length !== 0) {//获取弹框中最后选中的记录
                this.vvlPopTableRowDbClick(this.tablePopoverVVLSelection[0]);
            }
            // 关闭弹框
            this.$refs.popover.showPopper = false;
            this.resetVVLPopTableData();
        },
        /**
         * 关闭按钮点击事件
         */
        vvlPopoverClose() {
            this.$refs.popover.showPopper = false;
            this.resetVVLPopTableData();
        },
        /**
         * 船名航次弹框数据分页条
         */
        popVVLHandleDemand() {
            this.vvlPopoverSearch();
        },
        popVVLHandleSizeChange(val) {
            this.popPageSize = val;
            this.popVVLHandleDemand();
            this.$emit("backTop");
        },
        popVVLHandleCurrentChange(val) {
            this.popPageNum = val;
            this.popVVLHandleDemand();
            this.$emit("backTop");
        },
        /**
         * 船名航次表格行点击击事件
         */
        vvlPopTableRowClick(row) {
            this.tablePopoverVVLSelection = [row];
        },
        /**
         * 船名航次表格行双击事件（某行被双击时,自动关闭弹框,获取该行船名航次数据,赋值订舱查询页船名航次输入框）
         */
        vvlPopTableRowDbClick(row) {
            this.freightAddDialogSearch.vesselCode = row.vesselCode;
            this.freightAddDialogSearch.voyageNo = row.voyageNo;
            this.freightAddDialogSearch.voyageLeg = row.voyageLeg;
            this.$refs.popover.showPopper = false;
            this.resetVVLPopTableData();
        },
        resetVVLPopTableData() {
            this.tablePopoverVVLInfo = [];
            this.tablePopoverVVLSelection = [];
        },

        /************************************ 费用查询弹出框 ************************************/
        /**
         * 搜索按钮点击事件
         */
        chargeCodePopoverSearch() {
            if (this.isPopSearchClick) {
                return;
            }
            this.isPopSearchClick = true;
            // 声明一个loading对象
            this.loadingtuo = this.$loading({
                lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                text: this.$t('message.searching'),     //加载动画的文字
                spinner: 'el-icon-loading',             // 引入的loading图标
                background: "rgb(0,0,0,0.1)",
                target: document.querySelector(".chargeCodePopover") // 设置加载动画区域
            });
            let that = this;
            this.axios({
                method: 'post',
                url: '/api/codedict/getChargeCodeList',
                data: {
                    chargeCode: this.chargePopoverSearch.chargeCode,
                    chargeName: this.chargePopoverSearch.chargeName,
                    chargeNameCn: this.chargePopoverSearch.chargeNameCn,
                    pageNum: this.chargePopoverSearch.popPageNum,
                    pageSize: this.chargePopoverSearch.popPageSize
                },
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                that.loadingtuo.close();
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    this.tablePopoverChargeInfo = response.data.object.list;
                    this.chargePopoverSearch.popTotal = response.data.object.total;
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
                this.isPopSearchClick = false;
            }).catch(error => {
                that.loadingtuo.close();
                this.isPopSearchClick = false;
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
        /**
         * 确认按钮点击事件
         */
        chargeCodePopoverConfirm() {
            // 赋值选中记录的费用代码到费用查询输入框中
            if (this.tablePopoverChargeSelection.length !== 0) {//获取弹框中最后选中的记录
                this.chargePopTableRowDbClick(this.tablePopoverChargeSelection[0]);
            }
            // 关闭弹框
            this.$refs.chargeCodePopover.showPopper = false;
            this.resetChargePopTableData();
        },
        /**
         * 关闭按钮点击事件
         */
        closeChargeCodePopoverView() {
            this.$refs.chargeCodePopover.showPopper = false;
            this.resetChargePopTableData();
        },
        /**
         * 费用代码表格行点击击事件
         */
        chargePopTableRowClick(row) {
            this.tablePopoverChargeSelection = [row];
        },
        /**
         * 费用代码表格行双击事件（某行被双击时,自动关闭弹框,获取该行费用代码,赋值费用代码查询输入框）
         */
        chargePopTableRowDbClick(row) {
            this.freightAddDialogSearch.chargeCode = row.chargeCode;
            this.$refs.chargeCodePopover.showPopper = false;
            this.resetChargePopTableData();
        },
        resetChargePopTableData() {
            this.tablePopoverChargeInfo = [];
            this.tablePopoverChargeSelection = [];
        },
        /**
         * 费用查询数据分页条
         */
        popChargeHandleDemand() {
            this.chargeCodePopoverSearch();
        },
        popChargeHandleSizeChange(val) {
            this.chargePopoverSearch.popPageSize = val;
            this.popChargeHandleDemand();
            this.$emit("backTop");
        },
        popChargeHandleCurrentChange(val) {
            this.chargePopoverSearch.popPageNum = val;
            this.popChargeHandleDemand();
            this.$emit("backTop");
        },

        /************************************ 添加费用弹出框 ************************************/
        /**
         * 费用查询弹框数据分页条
         */
        popFreightHandleDemand() {
            this.freightDialogSearchBtnCLick();
        },
        popFreightHandleSizeChange(val) {
            this.freightAddDialogSearch.popPageSize = val;
            this.popFreightHandleDemand();
            this.$emit("backTop");
        },
        popFreightHandleCurrentChange(val) {
            this.freightAddDialogSearch.popPageNum = val;
            this.popFreightHandleDemand();
            this.$emit("backTop");
        },
        /**
         * 查询按钮点击事件
         */
        freightDialogSearchBtnCLick() {
            if (this.isSearchClick) {//上一次查询未结束时不允许重复发起请求
                return;
            }
            this.isSearchClick = true;

            // 查询条件校验
            if(!this.validateSearch()){
                this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                return;
            }

            // 记录当前已添加进对账单的费用明细id，在查询时排除这些费用
            let excludeBkFreightReceiveIds = [];
            this.tableFreightReceivableInfo.forEach((freight) => {
                if (freight.bkFreightReceiveId != null && freight.bkFreightReceiveId !== "") {
                    excludeBkFreightReceiveIds.push(freight.bkFreightReceiveId);
                }
            });

            // 声明一个loading对象
            this.loadingtuo = this.$loading({
                lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                text: this.$t('message.searching'),    //加载动画的文字
                spinner: 'el-icon-loading',             // 引入的loading图标
                background: "rgb(0,0,0,0.1)",
                // target: document.querySelector(".searchList") // 设置加载动画区域
            });
            let that = this;
            this.axios({
                method: 'post',
                url: '/api/booking/freightsReceivableAddQuery',
                data: {
                    vesselCode: this.freightAddDialogSearch.vesselCode,
                    voyageNo: this.freightAddDialogSearch.voyageNo,
                    voyageLeg: this.freightAddDialogSearch.voyageLeg,
                    voyageYear: this.freightAddDialogSearch.year,
                    voyageMonth: this.freightAddDialogSearch.month,
                    saillingDateFrom: this.freightAddDialogSearch.sailingTimeStart === "" ? "" : this.formatDate(
                        {date: this.freightAddDialogSearch.sailingTimeStart, formatStr: 'yyyy-MM-dd'}
                    ),
                    saillingDateTo: this.freightAddDialogSearch.sailingTimeEnd === "" ? "" : this.formatDate(
                        {date: this.freightAddDialogSearch.sailingTimeEnd, formatStr: 'yyyy-MM-dd'}
                    ),
                    blNo: this.freightAddDialogSearch.blNo,
                    chargeCode: this.freightAddDialogSearch.chargeCode,
                    currency: this.freightAddDialogSearch.currency,
                    excludeBkFreightReceiveIds: excludeBkFreightReceiveIds.join(','),
                    pageNum: this.freightAddDialogSearch.popPageNum,
                    pageSize: this.freightAddDialogSearch.popPageSize,
                },
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(response => {
                this.responseCode = response.data.backMessage;
                if (response.data.backCode === "200") {
                    // 赋值费用信息
                    if(response.data.object != null && response.data.object[0] != null){
                        this.tableDialogFreightInfo = response.data.object[0];
                    }
                    if(response.data.object != null && response.data.object[2] != null){
                        this.freightAddDialogSearch.popTotal = response.data.object[2];
                    }
                    // 赋值航次信息
                    if(response.data.object != null && response.data.object[1] != null){
                        this.tableDialogVoyageInfo = response.data.object[1];
                    }
                } else {
                    this.showMessage(false, this.responseCode, "error");
                }
                that.loadingtuo.close();
                this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
                that.loadingtuo.close();
                this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
            });
        },
        /**
         * 查询条件校验
         */
        validateSearch(){
            // 船名航次与年份月份不能同时为空
            let vvlIsNullFlag = !(this.freightAddDialogSearch.vesselCode || this.freightAddDialogSearch.voyageNo || this.freightAddDialogSearch.voyageLeg);
            let ymIsNullFlag = !(this.freightAddDialogSearch.year || this.freightAddDialogSearch.month);
            if(vvlIsNullFlag && ymIsNullFlag){
                this.showMessage(false, this.$t('billsManagement.message.leastOne'), "warning");
                return false;
            }
            return true;
        },
        /**
         * 重置按钮点击事件
         */
        freightDialogResetBtnCLick() {
            this.freightAddDialogSearch.vesselCode = "";
            this.freightAddDialogSearch.voyageNo = "";
            this.freightAddDialogSearch.voyageLeg = "";
            this.freightAddDialogSearch.sailingTimeStart = "";
            this.freightAddDialogSearch.sailingTimeEnd = "";
            this.freightAddDialogSearch.blNo = "";
            this.freightAddDialogSearch.year = "";
            this.freightAddDialogSearch.month = "";
            this.freightAddDialogSearch.chargeCode = "";
            this.freightAddDialogSearch.currency = "";
            this.freightAddDialogSearch.popPageCount = 5;
            this.freightAddDialogSearch.popPageNum = 1;
            this.freightAddDialogSearch.popPageSize = 5;
            this.freightAddDialogSearch.popTotal = 0;
        },
        /**
         * 添加费用弹框全选/反选按钮点击
         */
        freightDialogCheckAllBtnClick(isCheck) {
            this.tableDialogVoyageInfoChecked = [];
            this.tableDialogFreightInfoChecked = [];
            // 查询航次信息全选/反选
            this.tableDialogVoyageInfo.forEach((item, index) => {
                this.tableDialogVoyageCheckOneMethod(index, isCheck)
            });
            // 查询费用信息全选/反选
            this.tableDialogFreightInfo.forEach((item, index) => {
                this.tableDialogFreightCheckOneMethod(index, isCheck)
            })
        },
        tableDialogVoyageCheckOneMethod(index, type) {
            let curData = this.tableDialogVoyageInfo[index];
            if (type) {//选中
                this.tableDialogVoyageInfoChecked.push(curData);
                this.$refs.tableDialogVoyageInfo.toggleRowSelection(curData, true);
            } else {//取消选中
                this.tableDialogVoyageInfoChecked.forEach((item, index) => {
                    if (item.bkFreightReceiveId === curData.bkFreightReceiveId) {
                        this.tableDialogVoyageInfoChecked.splice(index, 1);
                    }
                });
                this.$refs.tableDialogVoyageInfo.toggleRowSelection(curData);
            }
        },
        tableDialogFreightCheckOneMethod(index, type) {
            let curData = this.tableDialogFreightInfo[index];
            if (type) {//选中
                this.tableDialogFreightInfoChecked.push(curData);
                this.$refs.tableDialogFreightInfo.toggleRowSelection(curData, true);
            } else {//取消选中
                this.tableDialogFreightInfoChecked.forEach((item, index) => {
                    if (item.bkFreightReceiveId === curData.bkFreightReceiveId) {
                        this.tableDialogFreightInfoChecked.splice(index, 1);
                    }
                });
                this.$refs.tableDialogFreightInfo.toggleRowSelection(curData);
            }
        },
        tableDialogFreightCancelCheckedMethod(index) {
            let curData = this.tableDialogFreightInfo[index];
            this.tableDialogFreightInfoChecked.forEach((item, index) => {
                if (item.bkFreightReceiveId === curData.bkFreightReceiveId) {
                    this.tableDialogFreightInfoChecked.splice(index, 1);
                }
            });
            this.$refs.tableDialogFreightInfo.toggleRowSelection(curData, false);
        },
        /**
         * 确认按钮点击事件
         */
        freightDialogConfirmBtnClick() {
            // 校验是否有勾选费用明细
            if (this.tableDialogFreightInfoChecked.length <= 0) {
                this.showMessage(false, this.$t('billsManagement.message.notSelected'), "warning");
            } else {
                // 将勾选的费用明细追加到对账单费用明细表格
                this.tableDialogFreightInfoChecked.forEach((addFreight) => {
                    addFreight.rowStatus = 4;
                    addFreight.payerName = addFreight.customerName;
                    addFreight.payerNameCn = addFreight.customerNameCn;
                    this.tableFreightReceivableInfo.push(addFreight);
                });
                // 添加完成，关闭弹框
                this.freightAddDialogShow = false;
                // 刷新对账单费用明细汇总表格
                this.setFreightTotalTableData();
            }
        },
        /**
         * 关闭按钮点击事件
         */
        freightDialogCloseBtnClick() {
            // 打开添加费用弹框
            this.freightAddDialogShow = false;
            this.resetFreightDialogData();
        },
        resetFreightDialogData() {
            // 还原查询参数
            this.freightDialogResetBtnCLick();
            // 清空费用及航次信息
            this.tableDialogVoyageInfo = [];
            this.tableDialogFreightInfo = [];
            // 清空弹框多选费用列表
            this.tableDialogFreightInfoChecked = [];
            this.tableDialogFreightInfoChecked = [];
            // 年份、月份初始化
            this.initYears();
        },

        /************************************ 其他事件 *************************************/
        /**
         * 数字保留2位小数
         */
        toDecimal2(x) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return false;
            }
            var ff = Math.round(x * 100) / 100;
            var s = ff.toString();
            var rs = s.indexOf('.');
            if (rs < 0) {
                rs = s.length;
                s += '.';
            }
            while (s.length <= rs + 2) {
                s += '0';
            }
            return s;
        },
        /**
         * Tab页点击切换事件
         */
        handleClick(tab, event) {
        },
        /**
         * 下拉控件国际化显示 公共方法
         */
        getDisplayValue(item) {
            return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
        },
        /**
         * 费用信息表格 费项名称国际化显示（公共方法）
         */
        getChargeNameDisplayValue(item) {
            if(item == null){
                return '';
            }
            return localStorage.getItem('locale') == 'en' ? item.chargeName : item.chargeNameCn
        },
        /**
         * 费用信息表格 客户名称国际化显示 公共方法
         */
        getCustomerNameDisplayValue(item){
            if(item == null){
                return '';
            }
            return localStorage.getItem('locale') == 'en' ? item.payerName : item.payerNameCn
        },
        /**
         * 根据货物类型代码获取货物类型名称
         */
        getCargoTypeName(cargoTypeCode) {
            let cargoTypeName = cargoTypeCode;
            try {
                if (cargoTypeCode !== "") {
                    if (this.cargoTypeOptions.length <= 0) {
                        this.cargoTypeFocus();
                    }
                    this.cargoTypeOptions.forEach((item) => {
                        if (item.codeValue === cargoTypeCode) {
                            cargoTypeName = this.getDisplayValue(item);
                            throw new Error("EndForEach");
                        }
                    })
                }
            } catch (error) {
                if (error.message === "EndForEach") {
                    return cargoTypeName;
                } else {
                    this.showMessage(false, error, "error");
                }
            }
        },
        /**
         * 页面重置公共方法 公共方法
         */
        refreshPage() {
            // 还原按钮控制状态
            this.isSaveClick = false;
            this.isSearchClick = false;
            // 清空待删除费用明细数组
            this.tableFreightReceivableInfoDeleted = [];

            // 清空表格数据
            this.tableVoyageInfoChecked = [];
            this.tableBLNoInfoChecked = [];
            this.tableFreightReceivableInfoChecked = [];
            this.tableFreightReceivableInfoDeleted = [];
            this.tableDialogVoyageInfoChecked = [];
            this.tableDialogVoyageInfo = [];
            this.tableDialogFreightInfoChecked = [];
            this.tableDialogFreightInfo = [];
        },

        /************************************ 基础数据下拉框赋值 ************************************/
        /**
         * 币种下拉选赋值
         */
        currencyCodeFocus() {
            const _this = this;
            this.axios({
                method: "get",
                url: "/api/codedict/getCurrencyCodeList",
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(function (response) {
                _this.currencyOptions = response.data.object
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },

        /************************************ 页面数据初始化 ************************************/
        /**
         * 年月控件下拉选赋值
         */
        initYears() {
            this.yearOptions = [];
            this.monthOptions = [];
            let nowDate = new Date();
            let curYear = nowDate.getFullYear();
            let curMonth = nowDate.getMonth();
            for (let i = 0; i < 10; i++) {
                this.yearOptions.push({value: (curYear - i), label: (curYear - i)})
            }
            for (let j = 1; j <= 12; j++) {
                this.monthOptions.push({value: j, label: j})
            }
            // // 初始化添加费用弹框年份月份参数
            this.freightAddDialogSearch.year = curYear;
            this.freightAddDialogSearch.month = curMonth + 1;
        },
        initPageInfo() {
            // if (this.$route.params == null) {
            //     return;
            // }
            // if (this.$route.params.statementOfAccountInfo == null) {
            //     return;
            // }
            // // 获取路由传递对账单信息
            // let statementOfAccountInfo = this.$route.params.statementOfAccountInfo;
            if(sessionStorage.getItem("PASSING_PARAMETERS") == null){
                return;
            }
            let statementOfAccountInfo = JSON.parse(sessionStorage.getItem("PASSING_PARAMETERS"));

            // 由费用确认页面跳转过来时需获取对账费用信息
            let freightDetails = [];
            // if (this.$route.params.freightReceiveVos != null) {
            //     let freightReceiveVos = this.$route.params.freightReceiveVos;
            if(sessionStorage.getItem("PASSING_PARAMETERS_1") != null){
                let freightReceiveVos = JSON.parse(sessionStorage.getItem("PASSING_PARAMETERS_1"));
                // 将费用明细转换为对账单明细
                freightReceiveVos.forEach((freightReceiveVo) => {
                    let soaDetail = {};
                    soaDetail.bkFreightReceiveId = freightReceiveVo.bkFreightReceiveId;
                    soaDetail.vesselCode = freightReceiveVo.vesselCode;
                    soaDetail.voyageNo = freightReceiveVo.voyageNo;
                    soaDetail.voyageLeg = freightReceiveVo.voyageLeg;
                    soaDetail.vesselName = freightReceiveVo.vesselName;
                    soaDetail.saillingDate = freightReceiveVo.saillingDate;
                    soaDetail.blNo = freightReceiveVo.blNo;
                    soaDetail.chargeCode = freightReceiveVo.chargeCode;//费项代码
                    soaDetail.chargeName = freightReceiveVo.chargeName;//费项名称
                    soaDetail.chargeNameCn = freightReceiveVo.chargeNameCn;//费项名称CN
                    soaDetail.caculateQty = freightReceiveVo.caculateQty;
                    soaDetail.caculateUnit = freightReceiveVo.caculateUnit;
                    soaDetail.currency = freightReceiveVo.currency;
                    soaDetail.amount = freightReceiveVo.amount;
                    soaDetail.payModel = freightReceiveVo.payModel;
                    soaDetail.payer = freightReceiveVo.payer;
                    soaDetail.payerName = freightReceiveVo.customerName;
                    soaDetail.payerNameCn = freightReceiveVo.customerNameCn;
                    if (freightReceiveVo.agreementId != null
                        && freightReceiveVo.agreementId !== "") {
                        if (freightReceiveVo.agreementId.indexOf(",") < 0) {
                            soaDetail.cargoTypeCode = "";// 货类
                            soaDetail.agreementNo = freightReceiveVo.agreementId;// 协议号
                        } else {
                            soaDetail.cargoTypeCode =
                                freightReceiveVo.agreementId.substring(
                                    freightReceiveVo.agreementId.indexOf(",") + 1).trim();// 货类
                            soaDetail.agreementNo =
                                freightReceiveVo.agreementId.substring(
                                    0,
                                    freightReceiveVo.agreementId.indexOf(",")).trim();// 协议号
                        }
                    }
                    soaDetail.containerType = freightReceiveVo.containerType;
                    freightDetails.push(soaDetail);
                });

                if (freightDetails.length > 0) {
                    freightDetails.forEach((detail) => {
                        statementOfAccountInfo.soaDetails.push(detail);
                    });
                }
                this.setFieldValue(statementOfAccountInfo);
            } else {
                // 由对账单查询页面跳转过来，需根据对账单id获取到最新数据
                this.axios({
                    method: 'post',
                    url: '/api/statementOfAccount/statementOfAccountDetailsQuery/' + statementOfAccountInfo.statementOfAccountId,
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.setFieldValue(response.data.object);
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            }

            this.$nextTick(() => {//等待页面渲染好之后再调用，否则获取不到this.refs
                this.refreshPage();
            });
        },
        setFieldValue(statementOfAccountInfo) {
            // 重置页面数据
            this.refreshPage();

            this.statementOfAccount = statementOfAccountInfo;
            // 【赋值费用信息】
            if (statementOfAccountInfo.soaDetails != null
                && statementOfAccountInfo.soaDetails.length > 0) {
                this.tableFreightReceivableInfo = statementOfAccountInfo.soaDetails;
            }
            // 刷新对账单费用明细汇总表格
            this.setFreightTotalTableData();
        },
        /**
         * 费用数据有改动过，刷新其他表格汇总数据
         */
        setFreightTotalTableData() {
            // 清空原有的表格汇总数据
            this.tableVoyageInfo = [];
            this.tableBLNoInfo = [];
            this.tableCurrencyAmountInfo = [];

            let vvlList = [];
            let blNoList = [];
            let currencyList = [];
            let map = new Map();
            // 遍历费用明细，汇总船名航次、提单
            this.tableFreightReceivableInfo.forEach((item) => {
                let vvl = item.vesselCode + "," + item.vesselName + "," + item.voyageNo + "," + item.voyageLeg;
                let blNo = item.blNo;
                let currency = item.currency;
                let amount = item.amount;

                if (!vvlList.includes(vvl)) {
                    vvlList.push(vvl);
                }
                if (!blNoList.includes(blNo)) {
                    blNoList.push(blNo);
                }
                if (!currencyList.includes(currency)) {
                    currencyList.push(currency);
                    map.set(currency, amount);
                } else {
                    // 累加金额
                    map.set(currency, amount + (map.get(currency)));
                }
            });

            // 【赋值应收金额信息】
            currencyList.forEach((item) => {
                this.tableCurrencyAmountInfo.push({checked: false, currency: item, amount: map.get(item)})
            });


            // 【赋值航次信息】
            for (let i = 0; i < vvlList.length; i++) {
                let split = vvlList[i].split(",");
                this.tableVoyageInfo.push({
                    vesselCode: split[0],
                    vesselName: split[1],
                    voyageNo: split[2],
                    voyageLeg: split[3]
                })
            }

            // 【赋值提单信息】
            blNoList.forEach((item) => {
                this.tableBLNoInfo.push({checked: false, blNo: item})
            });
        },
        /**
         * 基础数据下拉选赋值
         */
        initCombos() {
            this.cargoTypeFocus();
        },
        /**
         * 货类
         */
        cargoTypeFocus() {
            const _this = this;
            this.axios({
                method: "get",
                url: "/api/codedict/getCargoTypeList",
                headers: {
                    'Accept-language': localStorage.getItem("locale")
                }
            }).then(function (response) {
                _this.cargoTypeOptions = response.data.object
            }).catch(error => {
                if (error.data) {
                    this.responseCode = error.data.backMessage;
                    this.showMessage(false, this.responseCode, "error");
                } else {
                    this.showMessage(false, error, "error");
                }
            });
        },
    },
    mounted() {
    },
    created() {
        this.initPageInfo();
        this.initCombos();
        this.initYears();
        this.$parent.updateHeaderAside();
    }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/base";
@import "../../../assets/scss/public";

.el-row {
    margin-bottom: 0;

    &:last-child {
        margin-bottom: 0;
    }
}

.el-col {
    margin-bottom: 0;
    border-radius: 4px;
}

.inputName-left {
    flex: 1;
    margin: 0 5px;
}

.packageTypeButton {
    width: 25px;
    height: 25px;
    margin-top: 2px;
}

.cardBox {
    background: $colorA;
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
    border-radius: 3px;
    padding: 16px 16px 1px 16px;
}

.lastCardBox {
    width: 59.5%;
    margin-right: 0.5%;
    height: 80px;
}

.lastCardBox2 {
    width: 59.5%;
    height: 80px;
}

.cardTitle {
    margin-bottom: 10px;

    span {
        font-size: $fontE;
        color: rgba(0, 0, 0, 0.85);
        letter-spacing: 0;
        font-weight: 600;
        margin-left: 6px;
    }
}

.cardTitle2 {
    margin-top: 10px;

    span {
        font-size: $fontE;
        color: rgba(0, 0, 0, 0.85);
        letter-spacing: 0;
        font-weight: 600;
        margin-left: 6px;
    }
}

.collapseTitle {
    margin-bottom: 10px;

    span {
        font-size: $fontE;
        color: rgba(0, 0, 0, 0.85);
        letter-spacing: 0;
        font-weight: 600;
        margin-left: 6px;
    }
}

.collapseItem {
    margin-top: -16px;
}

.setting {
    justify-content: flex-start;

    ul {
        li {
            margin-right: 15px;
            color: #6d7278;
            font-size: $fontB;
        }
    }
}

/*给el-table滚动条设置宽度和高度*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; // 横向滚动条
    height: 10px; // 纵向滚动条 必写
}

.position-right {
    height: 20px;
    text-align: right;
}

.topMargin {
    margin-top: 20px;
}

.popoverInner {
    margin: 5px;
    margin-top: 0;
}

.inputName-title-left-textarea3 {
    height: 52px;
    line-height: 53px;
}

/deep/ .el-collapse-item__header {
    padding: 16px 16px 1px 16px;
}

/deep/ .el-collapse-item__content {
    padding: 16px 16px 1px 16px;
}

/deep/ .el-icon-arrow-right {
    border-radius: 50%;
    border: 2px solid #e8e8e8;
    color: #2867ce;
    font-size: $fontE;
    font-weight: 600;
}

.el-image.el-image__error {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    background: #F5F7FA;
    color: #C0C4CC;
    vertical-align: middle;
}

.inputName {
    flex: 1;
    margin: 2px 5px;
}

::v-deep .el-tabs__content {
    background: #fff;
    padding: 0 0;
}

//重写el-input样式，只显示下边框
.inputName ::v-deep.el-input__inner {
    border-radius: 0; // 去掉圆角
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0;
    border-bottom-width: 1px; //只显示下边框
}

.inputName ::v-deep.el-input.is-disabled .el-input__inner {
    background-color: #FFFFFF;
    border-color: #E4E7ED;
    color: black;
    cursor: not-allowed;
}

.voyageIcon {
    margin-left: 5px;
    margin-top: 2px;
    width: 25px;
    height: 25px;
    border: 1px solid #0091ff;
    border-radius: 4px;
}

.chargeCodeButton {
    height: 25px;
    margin-top: 3px;
}

.boatBox {
    position: relative;

    .boatBox-list-box {
        min-width: 280px;
        position: absolute;
        left: 51px;
        top: 30px;
        background: $colorA;
        padding: 5px 10px;
        z-index: 100;
        border: 1px solid $colorE;
        font-size: $fontC;
        font-weight: 600;

        .boatBox-top {
            width: 100%;
            height: 20px;
            line-height: 20px;
            background: $colorB;
        }

        .left {
            width: 30%;
            margin-right: 4%;
        }

        .right {
            width: 66%;
        }

        ul {
            padding: 0;
            margin: 0;

            li {
                border-bottom: 1px solid #e7f0fc;
                padding: 4px 2px;
            }

            li:last-of-type {
                border: none;
            }

            li:hover {
                background: rgb(224, 240, 245);
            }
        }
    }
}

</style>
<style lang="scss">
.el-tabs__content {
    background: #fff;
}

//全选icon
.el-icon-my-selectAll {
    background: url('../../../assets/image/icon/selectAll.png') center center no-repeat;
    font-size: 16px;
    background-size: cover;
}

.el-icon-my-selectAll:before {
    content: "替";
    font-size: 16px;
    visibility: hidden;
}

//反选icon
.el-icon-my-selectInverse {
    background: url('../../../assets/image/icon/selectInverse.png') center center no-repeat;
    font-size: 16px;
    background-size: cover;
}

.el-icon-my-selectInverse:before {
    content: "替";
    font-size: 16px;
    visibility: hidden;
}

</style>